var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.1717 11.9997L8.22168 7.04974L9.63568 5.63574L15.9997 11.9997L9.63568 18.3637L8.22168 16.9497L13.1717 11.9997Z","fill":"currentColor"}));
}

ChevronRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
